import * as types from './meeting-boards.types';

export const meetingBoardsPageSelectors: types.IMeetingBoardsPageSelectors = {
  selectMeetingBoards: (state) => state.page.meetingBoards.meetingBoards,
};
